import { CourseType, URI } from '../../contracts/enums';
import * as UI from './styles';
import logo from '../../assets/icons/logo.svg';
import logoGreen from '../../assets/icons/logo_green.svg';
import hamburguer from '../../assets/icons/hamburguer.svg';
import physics from '../../styles/themes/physics';
import physicsSvg from '../../assets/icons/physics.svg';
import chemistry from '../../styles/themes/chemistry';
import { useCourse } from '../../contexts/course';
import { Fragment, ReactNode, useCallback, useContext, useEffect, useMemo, useRef, useState } from 'react';
import * as UISide from '../SideBar/styles';
import { ThemeContext } from 'styled-components';
import AppThemeContext from '../../contexts/theme';
import MenuItem from '../MenuItem';
import { ChemistryIcon, IconComponent, MedCoinIcon, TypeIcons } from '../Icon';
import { local } from '../../storage';
import { useHistory } from 'react-router-dom';
import Avatar from 'react-avatar';
import { useAuth } from '../../contexts/auth';

function HeaderMobile() {
  const { type, setTypeCourse: setType } = useCourse();
  const [showMenu, setShowMenu] = useState<boolean>(false);
  const [selectMenu, setSelectMenu] = useState<ReactNode>(undefined);
  const { user } = useAuth();
  const { colors } = useContext(ThemeContext);
  const { changeTheme, theme } = useContext(AppThemeContext);
  const [, refreshHeader] = useState<boolean>(false);
  const refMenu = useRef<HTMLDivElement>(null);
  const history = useHistory();

  useEffect(() => {
    refreshHeader(x => !x);
  }, [])

  const medCoins = useMemo(() => {
    return <Fragment>
      <MedCoinIcon style={{ marginLeft: 20, fontSize: '30px' }} />
      <span className="stat">{user?.coins}</span>
    </Fragment>
  }, [user?.coins])

  const toggleTheme = useCallback((title: CourseType) => {
    changeTheme(title === CourseType.physics ? physics : chemistry);
    setType(title);
  }, [changeTheme, setType]);

  useEffect(() => {
    console.log(history.location.pathname)
    if (history.location.pathname.includes(URI.dashboard)) {
      setSelectMenu(<div><IconComponent type={TypeIcons.home} style={{ color: '#5D5D5D' }} />Dashboard</div>)
    } else if (history.location.pathname.includes(URI.lessons.replace('/:id?', ''))) {
      setSelectMenu(<div><IconComponent type={TypeIcons.lesson} style={{ color: '#5D5D5D' }} />Aulas</div>)
    } else if (history.location.pathname.includes(URI.exams)) {
      setSelectMenu(<div><IconComponent type={TypeIcons.exam} style={{ color: '#5D5D5D' }} />Provas</div>)
    } else if (history.location.pathname.includes(URI.clinicalCase)) {
      setSelectMenu(<div><IconComponent type={TypeIcons.tutoring} style={{ color: '#5D5D5D' }} />Casos Clínicos</div>)
    } else if (history.location.pathname.includes(URI.monitoria)) {
      setSelectMenu(<div><IconComponent type={TypeIcons.monitoring} style={{ color: '#5D5D5D' }} />Mentorias</div>)
    } else if (history.location.pathname.includes(URI.handout)) {
      setSelectMenu(<div><IconComponent type={TypeIcons.material} style={{ color: '#5D5D5D' }} />Material Digital - Apostilas</div>)
    } else if (history.location.pathname.includes(URI.longExam)) {
      setSelectMenu(<div><IconComponent type={TypeIcons.material} style={{ color: '#5D5D5D' }} />Material Digital - Simulados</div>)
    } else if (history.location.pathname.includes(URI.examResolution)) {
      setSelectMenu(<div><IconComponent type={TypeIcons.material} style={{ color: '#5D5D5D' }} />Material Digital - Resoluções provas</div>)
    } else if (history.location.pathname.includes(URI.handoutResolution)) {
      setSelectMenu(<div><IconComponent type={TypeIcons.material} style={{ color: '#5D5D5D' }} />Material Digital - Resoluções apostila</div>)
    } else if (history.location.pathname.includes(URI.longExamResolution)) {
      setSelectMenu(<div><IconComponent type={TypeIcons.material} style={{ color: '#5D5D5D' }} />Material Digital - Resoluções simulados</div>)
    } else {
      setSelectMenu(undefined);
    }
  }, [history.location.pathname])

  return <UI.ContainerMobile>
    <div className='header'>
      <img onClick={() => setShowMenu(x => !x)} className='hamburguer-header' alt="hamburguer" src={hamburguer} />
      <img className='logo-header' src={type === CourseType.physics ? logo : logoGreen} alt="Logo Header" />
    </div>
    <div className='header-menu'>
      <div ref={refMenu} style={{ top: showMenu ? `-0px` : `calc(-0px - ${refMenu.current?.clientHeight}px)` }}>
        <div>
          <UISide.ThemeSwitcher>
            <UISide.ChemistryButton
              onClick={() => toggleTheme(CourseType.chemistry)}
              _bgColor={type === CourseType.chemistry ? colors.primary : 'transparent'}
              _hoverColor={
                type === CourseType.chemistry ? colors.primary : colors.secondary
              }
              _textColor={type === CourseType.chemistry ? colors.white : colors.dark_grey}
            >
              Química
            </UISide.ChemistryButton>

            <UISide.PhysicsButton
              onClick={() => toggleTheme(CourseType.physics)}
              _bgColor={type === CourseType.physics ? colors.primary : 'transparent'}
              _hoverColor={type === CourseType.physics ? colors.primary : colors.secondary}
              _textColor={type === CourseType.physics ? colors.white : colors.dark_grey}
            >
              Física
            </UISide.PhysicsButton>
          </UISide.ThemeSwitcher>
          <div className='hr' />
          <UISide.Menu>
            <MenuItem handle={() => setShowMenu(false)} className='menu-mobile' link={URI.dashboard} icon={TypeIcons.home} label="Dashboard" />
            <MenuItem handle={() => setShowMenu(false)} className='menu-mobile' link={URI.lessons.replace('/:id', '')} icon={TypeIcons.lesson} label="Aulas" />
            <MenuItem handle={() => setShowMenu(false)} className='menu-mobile' link={URI.exams} icon={TypeIcons.exam} label="Provas" />
            <MenuItem handle={() => setShowMenu(false)} className='menu-mobile' icon={TypeIcons.analytics} label="Estatísticas" isSoon={true} />
            <MenuItem handle={() => setShowMenu(false)} className='menu-mobile' link={URI.clinicalCase} icon={TypeIcons.tutoring} label="Casos Clínicos" />
            <MenuItem handle={() => setShowMenu(false)} className='menu-mobile' link={URI.monitoria} icon={TypeIcons.monitoring} label="Monitorias" />
            <MenuItem subMenuHandle={() => setShowMenu(false)} className='menu-mobile' subMenuClassName='submenu-mobile'
              subMenuBefore={<div className='submenu-mobile-item'></div>}
              icon={TypeIcons.material}
              label="Material digital"
              isAccordion
              submenus={[
                {
                  label: 'Apostilas',
                  link: URI.handout
                },
                {
                  label: 'Simulados',
                  link: URI.longExam
                },
                {
                  label: 'Resoluções provas',
                  link: URI.examResolution
                },
                {
                  label: 'Resoluções apostila',
                  link: URI.handoutResolution,
                },
                {
                  label: 'Resoluções simulados',
                  link: URI.longExamResolution
                },
              ]}
            />
            <div className='hr' />
            <MenuItem handle={() => setShowMenu(false)} className='menu-mobile' icon={TypeIcons.profile} isSoon={true} label="Perfil" />
            <MenuItem className='menu-mobile' icon={TypeIcons.logout} link={URI.base} handle={() => {
              setShowMenu(false);
              local.removeAll();
              window.location.reload();
            }} label="Sair" />
          </UISide.Menu>

        </div>
      </div>
    </div>
    <div className='menu-select'>
      {selectMenu}
    </div>
    <div className='header-info'>
      <UI.LeftSectionMobile>
        {theme.title === 'chemistry' ? <ChemistryIcon style={{ fontSize: '2rem' }} /> : <img src={physicsSvg} alt="Logo matéria" />}
        <span>{theme.title === 'chemistry' ? 'Química' : 'Física'}</span>
      </UI.LeftSectionMobile>
      <UI.RightSect>
        <div style={{
          width: 17,
          height: 17,
          display: 'flex',
          justifyContent: 'center',
          borderRadius: 30,
          border: `0.4rem solid ${colors.primary}`,
        }}>
          <Avatar
            size="20"
            style={{ position: 'relative', top: '-2px' }}
            textSizeRatio={2.8}
            color="#5D5D5D"
            round
            name={user?.name}
          />
        </div>
        {medCoins}
      </UI.RightSect>
    </div>
  </UI.ContainerMobile>;
}

export default HeaderMobile;
